import md5 from "js-md5";

export const getCorrectPasswordHash = () => {
  return md5(md5(process.env.REACT_APP_PASSWORD) + process.env.REACT_APP_PASSWORD);
};

export const validatePassword = () => {
  const token = localStorage.getItem("password");
  return token && token === getCorrectPasswordHash();
};

export const clearPasswordCache = () => {
  localStorage.removeItem("password");
};

export const hashPassword = (password) => {
  return md5(md5(password) + password);
};
